module.exports = __webpack_public_path__ + "img/footer_logo_BARCELONA.9e7da63f.svg";